import { CLEAN_SALON_RESPONSE_DATA } from 'actions/salon/cleanOnboardingResponse.types';
import { QUICK_SALON_CREATION_COMPLETED } from 'actions/salon/completeQuickCreation.types';
import { QUICK_SETUP_FAILURE, QUICK_SETUP_REQUEST, QUICK_SETUP_SUCCESS } from 'actions/salon/postQuickSalonData.types';
import {
  POST_SALON_DATA_FAILURE,
  POST_SALON_DATA_REQUEST,
  POST_SALON_DATA_SUCCESS,
} from 'actions/salon/postSalonData.types';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import asObject from 'utils/objects/asObject.util';

const DEFAULT = Object.freeze({
  isPosting: false,
  response: {},
  errorMessage: '',
  saved: false,
  quickSalonCreationCompleted: false,
});

const MAP = Object.freeze({
  [POST_SALON_DATA_REQUEST]: (state) => ({ ...state, isPosting: true }),
  [POST_SALON_DATA_SUCCESS]: (state, { response }) => ({ ...state, isPosting: false, response, saved: true }),
  [POST_SALON_DATA_FAILURE]: (state, { errorMessage }) => ({ ...state, isPosting: false, errorMessage }),
  [QUICK_SETUP_REQUEST]: (state) => ({ ...state, isPosting: true, quickSalonCreationCompleted: false }),
  [QUICK_SETUP_SUCCESS]: (state, { response }) => ({ ...state, isPosting: false, response, saved: true }),
  [QUICK_SETUP_FAILURE]: (state, { errorMessage }) => ({ ...state, isPosting: false, errorMessage }),
  [QUICK_SALON_CREATION_COMPLETED]: (state) => ({ ...state, quickSalonCreationCompleted: true }),
  [CLEAN_SALON_RESPONSE_DATA]: (state) => ({
    ...state,
    isPosting: false,
    errorMessage: '',
    response: {},
    saved: false,
  }),
});

const salonSetupReducer = (state, action) =>
  (MAP[action && action.type] || alwaysSame)(state || { ...DEFAULT }, asObject(action));

export default salonSetupReducer;
